module.exports = __webpack_public_path__ + "img/H2.765309f1.png";